import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { acss } from '@adornis/chemistry/directives/acss.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { goTo } from '@adornis/router/client/open-href.js';
import '@chancenlogistik/client/components/logistik-component-base-header.js';
import '@chancenlogistik/client/components/logistik-component-base-page-layout.js';
import '@chancenlogistik/client/components/logistik-component-shipping-details.js';
import '@chancenwerk/client/design/components/cr-grid.js';
import '@chancenwerk/design/components/cr-dropdown-search-selection.js';
import '@chancenwerk/design/components/cr-loading-state.js';
import { LogistikProductCategoryForUrl, LogistikRoutes } from '@chancenwerk/logistik/client/routes.js';
import { customElement } from 'lit/decorators.js';
import { html } from 'lit/html.js';

@customElement('logistik-page-orderings')
export class LogistikPageOrderings extends ChemistryLitElement {
  override render() {
    return html`
      <logistik-component-base-page-layout>
        <logistik-component-base-header
          pageTitle="Produktreihenfolgen"
          backRoute=${LogistikRoutes.landing}
        ></logistik-component-base-header>
        <cr-grid
          horizontal
          space="md"
          auto-fill-columns="250px"
          ${acss({
            'cr-card': { cursor: 'pointer', background: this.colors.accent, color: this.colors.light },
            'cr-icon': { fontSize: this.spacing.xl },
          })}
        >
          ${this._card({
            title: 'CHANCENheft',
            icon: 'library_books',
            category: LogistikProductCategoryForUrl.LEARNING_MATERIAL,
          })}
          ${this._card({
            title: 'Werbe- und Akquisematerial',
            icon: 'campaign',
            category: LogistikProductCategoryForUrl.ADVERTISING_MATERIAL,
          })}
          ${this._card({ title: 'Büromaterial', icon: 'work', category: LogistikProductCategoryForUrl.WORK_MATERIAL })}
          ${this._card({ title: 'Eintrittskarten', icon: 'event', category: LogistikProductCategoryForUrl.TICKETS })}
          ${this._card({ title: 'Mobiliar', icon: 'weekend', category: LogistikProductCategoryForUrl.FURNISHING })}
          ${this._card({
            title: 'CHANCENbrief',
            icon: 'history_edu',
            category: LogistikProductCategoryForUrl.CHANCEN_BRIEF,
          })}
          ${this._card({
            title: 'CHANCENreise-Zertifikat',
            icon: 'explore',
            category: LogistikProductCategoryForUrl.TRAVEL_CERTIFICATE,
          })}
          ${this._card({
            title: 'CHANCENakademie Workshop-Pakete',
            icon: 'inventory_2',
            category: LogistikProductCategoryForUrl.WORKSHOP_PACK,
          })}
          ${this._card({ title: 'CHANCENset', icon: 'package_2', category: LogistikProductCategoryForUrl.SET })}
        </cr-grid>
      </logistik-component-base-page-layout>
    `;
  }

  private _card({
    title,
    icon,
    category,
  }: {
    title: string;
    icon: string;
    category: LogistikProductCategoryForUrl;
  }): Renderable {
    return html`
      <cr-card
        href=${`${LogistikRoutes.orderings}/${category}`}
        ${css({ minHeight: '100px' })}
        @click=${() => goTo(`${LogistikRoutes.orderings}/${category}`)}
      >
        <cr-flex space="lg" crossaxis-center align="center">
          <cr-icon> ${icon} </cr-icon>
          <cr-text> ${title} </cr-text>
        </cr-flex>
      </cr-card>
    `;
  }
}
